
import { SERVER_URL } from "./server";

const Fetch = async (url = "", method, data = {}) => {
  const token =localStorage.getItem("USER_TOKEN")
  const response = await fetch(`${SERVER_URL + url}`, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      authorization:token
    },

    body: JSON.stringify(data),
  });
  return await response.json();
};

const Get = async (url = "") => {
  const token =localStorage.getItem("USER_TOKEN")

  const response = await fetch(`${SERVER_URL + url}`, {
    method: "GET",

    headers: {
      "Content-Type": "application/json",
      authorization:token
    },
  });

  return response.json();
};

export { Fetch, Get };
